import marvelEmitter from '@marvelapp/react-ab-test/lib/emitter';
import cloneDeep from 'lodash/cloneDeep';
import { useEffect, useState } from 'react';
import {
  CB_EXPERIMENT_1,
  EXPERIMENT_10,
  EXPERIMENT_11,
  EXPERIMENT_12,
  EXPERIMENT_13,
  EXPERIMENT_14,
  EXPERIMENT_15,
  EXPERIMENT_16,
  EXPERIMENT_17,
  EXPERIMENT_18,
  EXPERIMENT_19,
  EXPERIMENT_2,
  EXPERIMENT_20,
  EXPERIMENT_21,
  EXPERIMENT_22,
  EXPERIMENT_23,
  EXPERIMENT_3,
  EXPERIMENT_4,
  EXPERIMENT_5,
  EXPERIMENT_6,
  EXPERIMENT_7,
  EXPERIMENT_8,
  EXPERIMENT_9,
  FULLY_QUARTERLY_COUNTRY,
  INDIVIDUAL_NON_TRIAL_COUNTRY_ABTEST,
  NEW_PRICING_EXP_3_BILLING_VERSIONS,
} from '/imports/checkout/api/constants';
import {
  getAbtestWisePlansAmount,
  getPaymentPeriodText,
  getPaymentTrialDays,
  isNewPricingVariantExperiment3,
  isWithNonTrailEnabled,
} from '/imports/checkout/api/helpers';
import useBilling from '/imports/checkout/api/useBilling';
import { getCountry, getTemplateImageUrlForPreview, helperCurrencyFormatter } from '/imports/checkout/api/utils';
import { useResponsive } from '/imports/core/api/responsiveContext';
import useIntl from '/imports/core/api/useIntl';
import useWindowSize from '/imports/core/api/useWindowSize';
import {
  DICOLARE_LIMITED_HOST,
  FEF_HOST,
  getContactPageNumber,
  KUKARIO_LIMITED_HOST,
  NEWLY_EXP_SIDE_CHANGE_EXP_WON_LOCALE_DESKTOP,
  OZUARA_LIMITED_HOST,
} from '/lib/helpers';
import { useCheckoutBillingStore } from '/zustand/CheckoutBillingStore';
import { useCheckoutResumeStore } from '/zustand/CheckoutResumeStore';

export const useGetActivePlans = (
  isOneYearHideHost,
  isAutoApply,
  isR2route,
  isR1route,
  currentUser,
  isFooter = false,
) => {
  const { t, locale } = useIntl();
  let replacedValue = {};
  let paymentTrialDays = {};
  const { width } = useWindowSize();
  const { billingVersion, setCurrentPlan, plans, currentPlan, currency } = useBilling();
  const { isMobile, host } = useResponsive();
  const { resume } = useCheckoutResumeStore();
  const { countryCodeBilling } = useCheckoutBillingStore();
  const country = getCountry();
  const isRroute = isR2route || isR1route;
  const isLargeCurrency = currency === 'COP' || currency === 'ARS';
  const hostName = ['melhorcv', 'theresumeranger'];
  const isBrazil = (countryCodeBilling === 'BR' || country === 'BR') && hostName.includes(host);
  const WithNonTrial = isWithNonTrailEnabled(country, isMobile, host);
  const threePlansOffer = marvelEmitter.getActiveVariant('exp_three_offer_non_trial_plans');
  const withNontrail1 = threePlansOffer === 'with_non_trial_1';
  const withNontrail3 = threePlansOffer === 'with_non_trial_3';
  const [plan, setPlan] = useState(null);
  const mexicoPlans = marvelEmitter.getActiveVariant('exp_mexico_plans');
  const brazilPlans = marvelEmitter.getActiveVariant('exp_brazil_plans');
  const australiaPlans = marvelEmitter.getActiveVariant('exp_australia_plans');
  const southAfricaPlans = marvelEmitter.getActiveVariant('exp_southafrica_plans');
  const indonesiaPlans = marvelEmitter.getActiveVariant('exp_indonesia_plans');
  const canadaPlans = marvelEmitter.getActiveVariant('exp_canada_plans');
  const turkeyPlans = marvelEmitter.getActiveVariant('exp_turkey_plans');
  const andorraFinlandPlans = marvelEmitter.getActiveVariant('exp_andorra_finland_new_plans');
  const peruPlans = marvelEmitter.getActiveVariant('exp_peru_plans');
  const ukarineGreccePlans = marvelEmitter.getActiveVariant('exp_ukraine_greece_plans');
  const ParaguayPlans = marvelEmitter.getActiveVariant('exp_paraguay_plans');
  const indiaPlans = marvelEmitter.getActiveVariant('exp_new_india_plans');
  const israelPlans = marvelEmitter.getActiveVariant('exp_israel_plans');
  const pakistanPlans = marvelEmitter.getActiveVariant('exp_pakistan_plans');
  const philippinesPlans = marvelEmitter.getActiveVariant('exp_philippines_plans');
  const vietnamPlans = marvelEmitter.getActiveVariant('exp_vietnam_plans');
  const polandPlans = marvelEmitter.getActiveVariant('exp_poland_plans');
  const argentinaPlans = marvelEmitter.getActiveVariant('exp_argentina_plans');
  const lebanondPlans = marvelEmitter.getActiveVariant('exp_lebanon_plans');
  const initialPricingPlans = marvelEmitter.getActiveVariant('exp_initial_pricing');

  const WeeklyPlans_Var =
    turkeyPlans == 'var_3' ||
    threePlansOffer == '20m10w' ||
    mexicoPlans == '10m6w' ||
    philippinesPlans == '16q5w' ||
    vietnamPlans === '10m6w' ||
    polandPlans == '15m7w' ||
    polandPlans == '17m10w' ||
    brazilPlans == '9m4w' ||
    argentinaPlans == '8m4w' ||
    argentinaPlans == '8m5w' ||
    lebanondPlans == '8m5w';

  const fullyQuerterlyCountry = FULLY_QUARTERLY_COUNTRY.includes(country);

  const isNonTrailDayWise =
    threePlansOffer == 'with_non_trial_1_day_wise' ||
    threePlansOffer == 'with_non_trial_3_day_wise' ||
    southAfricaPlans == 'control_day_wise' ||
    southAfricaPlans == 'var_1_day_wise' ||
    southAfricaPlans == '9m4w14q_day_wise' ||
    philippinesPlans == '9m5w_day_wise' ||
    indiaPlans == 'var_1_day_wise' ||
    vietnamPlans === '10m6w_day_wise' ||
    philippinesPlans == '9m5w16q_day_wise' ||
    threePlansOffer === '20m10w_day_wise' ||
    ukarineGreccePlans == 'var_1_day_wise' ||
    australiaPlans == '39m10w_day_wise' ||
    polandPlans == '15m7w_day_wise' ||
    isR1route ||
    lebanondPlans == '8w11m';

  const isQuartlyPlans =
    fullyQuerterlyCountry ||
    withNontrail3 ||
    southAfricaPlans == 'var_1' ||
    mexicoPlans === 'var_2' ||
    ukarineGreccePlans == 'var_1' ||
    indonesiaPlans == 'var_2' ||
    ParaguayPlans == 'var_2' ||
    turkeyPlans == 'var_2' ||
    turkeyPlans == 'var_3' ||
    turkeyPlans == '10m6w16q' ||
    pakistanPlans === 'var_2' ||
    israelPlans == 'var_2' ||
    philippinesPlans == '16q5w' ||
    philippinesPlans == '9m5w_day_wise' ||
    threePlansOffer == '20m10w' ||
    mexicoPlans == '10m6w' ||
    vietnamPlans == '10m6w' ||
    philippinesPlans == '9m5w16q' ||
    australiaPlans == '39m10w' ||
    australiaPlans == '39m10w_day_wise' ||
    polandPlans == '15m7w' ||
    polandPlans == '17m10w' ||
    brazilPlans == '9m4w' ||
    brazilPlans == '9m4w15q' ||
    isNonTrailDayWise ||
    isR1route ||
    isR2route ||
    argentinaPlans ||
    lebanondPlans;

  const defaultPlan = () => {
    if (WithNonTrial) {
      if (threePlansOffer === 'with_non_trial_1') return 'Weekly Plan';
    }
    return '14-DAY LIMITED ACCESS';
  };

  const [activePlan, setActivePlan] = useState(defaultPlan);
  const getPlans = () => {
    const data = cloneDeep(plans);

    if (turkeyPlans == '10m6w16q') {
      return Array.isArray(data)
        ? data.filter((p) => p.experiment === EXPERIMENT_7 || p.experiment === EXPERIMENT_6)
        : [];
    } else if (philippinesPlans == '9m5w16q' || philippinesPlans == '9m5w16q_day_wise') {
      return Array.isArray(data)
        ? data.filter((p) => p.experiment === EXPERIMENT_13 || p.experiment === EXPERIMENT_4)
        : [];
    } else if (southAfricaPlans == '9m4w14q_day_wise') {
      return Array.isArray(data)
        ? data.filter((p) => p.experiment === EXPERIMENT_4 || p.experiment === EXPERIMENT_8)
        : [];
    } else if (isR2route) {
      return Array.isArray(data)
        ? data.filter((p) => p.experiment === EXPERIMENT_10 || p.experiment === EXPERIMENT_16)
        : [];
    } else if (argentinaPlans == '8m4w') {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_17) : [];
    } else if (argentinaPlans == '8m5w' || lebanondPlans == '8m5w') {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_18) : [];
    } else if (argentinaPlans == '15q8m') {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_19) : [];
    } else if (lebanondPlans == '14q8m') {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_20) : [];
    } else if (lebanondPlans == '8w11m') {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_21) : [];
    } else if (
      peruPlans === 'var_1' ||
      indonesiaPlans == 'var_1' ||
      ParaguayPlans == 'var_1' ||
      canadaPlans == '7w17m' ||
      australiaPlans == 'var_4'
    ) {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_9) : [];
    } else if (
      turkeyPlans == 'var_2' ||
      mexicoPlans === 'var_2' ||
      southAfricaPlans == 'var_1' ||
      southAfricaPlans == 'var_1_day_wise' ||
      ukarineGreccePlans == 'var_1' ||
      ukarineGreccePlans == 'var_1_day_wise' ||
      ParaguayPlans == 'var_2' ||
      indiaPlans == 'var_1' ||
      indiaPlans == 'var_1_day_wise' ||
      pakistanPlans === 'var_2' ||
      israelPlans == 'var_2'
    ) {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_8) : [];
    } else if (australiaPlans == 'var_2') {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_11) : [];
    } else if (
      turkeyPlans == 'var_3' ||
      mexicoPlans == '10m6w' ||
      threePlansOffer === 'with_non_trial_1' ||
      threePlansOffer == 'with_non_trial_1_day_wise' ||
      brazilPlans == 'var_2' ||
      andorraFinlandPlans == 'var_3' ||
      canadaPlans == '9w18m' ||
      israelPlans == '9w24m' ||
      polandPlans == '17m10w' ||
      vietnamPlans == '4w9m'
    ) {
      return Array.isArray(plans) ? plans.filter((p) => p.experiment === EXPERIMENT_6) : [];
    } else if (
      threePlansOffer === 'with_non_trial_3' ||
      indiaPlans == 'var_2' ||
      threePlansOffer == 'with_non_trial_3_day_wise' ||
      isR1route
    ) {
      return Array.isArray(plans) ? plans.filter((p) => p.experiment === EXPERIMENT_10) : [];
    } else if (indonesiaPlans == 'var_2') {
      return Array.isArray(plans) ? plans.filter((p) => p.experiment === EXPERIMENT_12) : [];
    } else if (philippinesPlans == '16q5w') {
      return Array.isArray(plans) ? plans.filter((p) => p.experiment === EXPERIMENT_13) : [];
    } else if (
      threePlansOffer == '20m10w' ||
      threePlansOffer == '20m10w_day_wise' ||
      australiaPlans == '39m10w' ||
      australiaPlans == '39m10w_day_wise' ||
      brazilPlans == '9m4w'
    ) {
      return Array.isArray(plans) ? plans.filter((p) => p.experiment === EXPERIMENT_14) : [];
    } else if (brazilPlans == '9m4w15q') {
      return Array.isArray(plans) ? plans.filter((p) => p.experiment === EXPERIMENT_15) : [];
    } else if (
      (WithNonTrial && threePlansOffer !== 'control') ||
      vietnamPlans ||
      philippinesPlans == '9m5w_day_wise' ||
      polandPlans == '15m7w' ||
      polandPlans == '15m7w_day_wise' ||
      mexicoPlans == 'var_1'
    ) {
      return Array.isArray(plans) ? plans.filter((p) => p.experiment === EXPERIMENT_4) : [];
    } else if (country === 'BR' && billingVersion === 5) {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_5 || p.name === 'APPLY OFFER') : [];
    } else if ((country == 'LU' || country == 'MO') && billingVersion !== 5) {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_22) : [];
    } else if (NEW_PRICING_EXP_3_BILLING_VERSIONS?.includes(billingVersion) && (country == 'LU' || country == 'MO')) {
      if (initialPricingPlans == 'new_pricing') {
        return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_23) : [];
      } else if (initialPricingPlans == 'control') {
        return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_22) : [];
      }
    } else if (isNewPricingVariantExperiment3(width) && NEW_PRICING_EXP_3_BILLING_VERSIONS?.includes(billingVersion)) {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_3 || p.name === 'APPLY OFFER') : [];
    } else if (billingVersion !== 3) {
      return Array.isArray(data) ? data.filter((p) => p.experiment === EXPERIMENT_2 || p.name === 'APPLY OFFER') : [];
    }
    return Array.isArray(data) ? data.filter((p) => p.experiment === CB_EXPERIMENT_1 || p.name === 'APPLY OFFER') : [];
  };

  const activePlansData = getPlans()
    .filter((p) => (WithNonTrial && threePlansOffer !== 'control' ? p.name : p.name !== '14-DAY FULL ACCESS'))
    .filter((p) => (isAutoApply ? p.name !== 'MONTHLY ACCESS' : p.name !== 'APPLY OFFER'))
    .filter((p) =>
      (WithNonTrial && threePlansOffer !== 'control' && isOneYearHideHost) || peruPlans == 'control'
        ? p.name !== '14-DAY FULL ACCESS'
        : isOneYearHideHost
          ? p.name !== 'MONTHLY ACCESS'
          : p.name,
    )
    .filter((d) => (turkeyPlans == '10m6w16q' ? !(d.experiment === 'EXP 6' && d.name === 'Monthly Plan') : d))
    .filter((d) =>
      philippinesPlans == '9m5w16q' || philippinesPlans == '9m5w16q_day_wise'
        ? !(d.experiment === 'EXP 4' && d.name === 'Weekly Plan')
        : d,
    )
    .filter((d) =>
      southAfricaPlans == '9m4w14q_day_wise' ? !(d.experiment === 'EXP 8' && d.name === 'Monthly Plan') : d,
    )
    .filter((d) => (isR2route ? !(d.experiment === 'EXP 16' && d.name !== 'Yearly Plan') : d))
    .filter((d) =>
      country == 'LU' || country == 'MO'
        ? !((d.experiment === 'EXP 22' || d.experiment === 'EXP 23') && d.name == '14-Day Full Access')
        : d,
    )
    .sort((a, b) => {
      if (isR2route && isFooter) {
        const order = ['Monthly Plan', 'Quarterly Plan', 'Yearly Plan'];
        return order.indexOf(a.name) - order.indexOf(b.name);
      }
      if (isR2route) {
        const order = ['Quarterly Plan', 'Yearly Plan', 'Monthly Plan'];
        return order.indexOf(a.name) - order.indexOf(b.name);
      }
      if (
        turkeyPlans == '10m6w16q' ||
        southAfricaPlans == '9m4w14q_day_wise' ||
        philippinesPlans == '9m5w16q' ||
        philippinesPlans == '9m5w16q_day_wise' ||
        brazilPlans == '9m4w15q'
      ) {
        const order = ['Monthly Plan', 'Weekly Plan', 'Quarterly Plan'];
        return order.indexOf(a.name) - order.indexOf(b.name);
      }
      if (a.name === '14-DAY LIMITED ACCESS') return -1;
      if (b.name === '14-DAY LIMITED ACCESS') return 1;
      if (a.name === 'Weekly Plan') return -1;
      if (b.name === 'Weekly Plan') return 1;
      if (australiaPlans == 'var_2' && a.name === 'Monthly Plan') return -1;
      if (australiaPlans == 'var_2' && b.name === 'Monthly Plan') return 1;
      if (a.name === 'Quarterly Plan') return -1;
      if (b.name === 'Quarterly Plan') return 1;
      if (a.name === 'Yearly Plan') return 1;
      if (b.name === 'Yearly Plan') return -1;
      const autoName = isAutoApply ? 'APPLY OFFER' : 'MONTHLY ACCESS';
      if (a.name === autoName) return 1;
      if (b.name === autoName) return -1;
      return 0;
    });

  if (WeeklyPlans_Var) {
    activePlansData.reverse();
  }

  const selectMonthlyPlan = (selectedPlan) => {
    const plan = getPlans().find((p) => p.name === selectedPlan);
    if (plan) {
      setCurrentPlan(plan);
    }
  };

  const selectYearlyPlan = (selectedPlan) => {
    const plan = getPlans().find((p) => p.name === selectedPlan);
    if (plan) {
      setCurrentPlan(plan);
    }
  };

  useEffect(() => {
    if (
      fullyQuerterlyCountry ||
      withNontrail3 ||
      threePlansOffer == 'with_non_trial_3_day_wise' ||
      southAfricaPlans == 'var_1' ||
      southAfricaPlans == 'var_1_day_wise' ||
      mexicoPlans === 'var_2' ||
      ukarineGreccePlans == 'var_1' ||
      ukarineGreccePlans == 'var_1_day_wise' ||
      indonesiaPlans == 'var_2' ||
      ParaguayPlans == 'var_2' ||
      turkeyPlans == 'var_2' ||
      pakistanPlans === 'var_2' ||
      israelPlans == 'var_2' ||
      philippinesPlans == '16q5w' ||
      isR2route ||
      argentinaPlans == '15q8m'
    ) {
      setActivePlan('Quarterly Plan');
      selectMonthlyPlan('Quarterly Plan');
    } else if (
      withNontrail1 ||
      threePlansOffer == 'with_non_trial_1_day_wise' ||
      brazilPlans == 'var_2' ||
      peruPlans === 'var_1' ||
      indonesiaPlans == 'var_1' ||
      ParaguayPlans == 'var_1' ||
      australiaPlans == 'var_4' ||
      ukarineGreccePlans == 'control' ||
      southAfricaPlans == 'control' ||
      southAfricaPlans == 'control_day_wise' ||
      mexicoPlans == 'var_1' ||
      pakistanPlans === 'var_1' ||
      andorraFinlandPlans == 'var_3' ||
      israelPlans == 'var_1' ||
      canadaPlans == '9w18m' ||
      canadaPlans == '7w17m' ||
      philippinesPlans == '9m5w_day_wise' ||
      vietnamPlans == '4w9m' ||
      (WithNonTrial && !INDIVIDUAL_NON_TRIAL_COUNTRY_ABTEST.includes(country))
    ) {
      setActivePlan('Weekly Plan');
      selectMonthlyPlan('Weekly Plan');
    } else if (
      australiaPlans == 'var_2' ||
      turkeyPlans == 'var_3' ||
      turkeyPlans == '10m6w16q' ||
      threePlansOffer == '20m10w' ||
      threePlansOffer == '20m10w_day_wise' ||
      southAfricaPlans == '9m4w14q_day_wise' ||
      mexicoPlans == '10m6w' ||
      vietnamPlans ||
      philippinesPlans == '9m5w16q' ||
      philippinesPlans == '9m5w16q_day_wise' ||
      australiaPlans == '39m10w' ||
      australiaPlans == '39m10w_day_wise' ||
      polandPlans ||
      brazilPlans == '9m4w15q' ||
      brazilPlans == '9m4w' ||
      argentinaPlans == '8m4w' ||
      argentinaPlans == '8m5w' ||
      lebanondPlans
    ) {
      setActivePlan('Monthly Plan');
      selectMonthlyPlan('Monthly Plan');
    } else {
      selectMonthlyPlan('14-DAY LIMITED ACCESS');
    }
  }, []);

  useEffect(() => {
    if (activePlan) {
      const currentPlan = activePlansData.find((j) => j.name == activePlan);
      setPlan(currentPlan);
    }
  }, [activePlan]);

  const handleTogglePlan = (plan) => {
    setActivePlan(plan);
    if (plan === 'MONTHLY ACCESS' || plan === 'APPLY OFFER') {
      selectYearlyPlan(plan);
    } else {
      selectMonthlyPlan(plan);
    }
  };

  const formatCurrency = (amount) => {
    const parts = helperCurrencyFormatter(amount, currency, locale);
    return parts
      .map(({ type, value }) => {
        switch (type) {
          case 'currency-prefix':
          case 'currency':
          case 'currency-postfix':
            return `<span class="currency">${value}</span>`;
          default:
            return value;
        }
      })
      .join('');
  };

  let CompanyContactNumber = '';
  if (
    FEF_HOST.includes(host) ||
    KUKARIO_LIMITED_HOST.includes(host) ||
    DICOLARE_LIMITED_HOST.includes(host) ||
    OZUARA_LIMITED_HOST.includes(host)
  ) {
    CompanyContactNumber = getContactPageNumber(host).value;
  } else {
    CompanyContactNumber = '+44 7360 532078';
  }

  if (currentPlan) {
    const { firstName, lastName } = currentUser || {};
    paymentTrialDays = getPaymentTrialDays(host, isMobile, currentPlan, isRroute);
    const paymentTermText = getPaymentPeriodText(currentPlan);
    const trialDays = paymentTrialDays.trialDays;
    let customerName = '';
    if (firstName && firstName?.trim()) {
      customerName = `, ${firstName?.trim()}.`;
    } else if (lastName && lastName?.trim()) {
      customerName = `, ${lastName?.trim()}.`;
    } else {
      customerName = '.';
    }
    replacedValue = {
      TRIALDAYS: trialDays,
      AMOUNT: formatCurrency(currentPlan?.amount) || '0.00',
      TIMELIMIT: t(paymentTermText.text),
      CONTACT_NUMBER: CompanyContactNumber,
      CUSTOMER_NAME: customerName,
    };
  }
  const templateImageUrl = getTemplateImageUrlForPreview(resume?.template, resume?.language, isMobile);

  const RtlSideExp = !isMobile && NEWLY_EXP_SIDE_CHANGE_EXP_WON_LOCALE_DESKTOP.includes(locale);

  const divedByWeekvars =
    turkeyPlans == 'var_3' ||
    turkeyPlans == '10m6w16q' ||
    threePlansOffer == '20m10w' ||
    southAfricaPlans == '10m6w' ||
    mexicoPlans == '10m6w' ||
    vietnamPlans === '10m6w' ||
    philippinesPlans == '9m5w16q' ||
    australiaPlans == '39m10w' ||
    polandPlans == '15m7w' ||
    polandPlans == '17m10w' ||
    brazilPlans == '9m4w' ||
    brazilPlans == '9m4w15q' ||
    argentinaPlans == '8m4w' ||
    argentinaPlans == '8m5w' ||
    lebanondPlans == '8m5w';

  const QuarterlyWeek =
    philippinesPlans == '16q5w' ||
    turkeyPlans == '10m6w16q' ||
    philippinesPlans == '9m5w16q' ||
    southAfricaPlans == '9m4w14q_day_wise' ||
    brazilPlans == '9m4w15q';

  const YearlyPlans = isR2route;

  const getFinalPrice = (planItem) => {
    if (!planItem) return 0;

    const amount = !planItem?.trialAmount
      ? getAbtestWisePlansAmount(host, isMobile, planItem).amount
      : getAbtestWisePlansAmount(host, isMobile, planItem).trialAmount;

    return isNonTrailDayWise
      ? amount / planItem.billingCycle
      : QuarterlyWeek && planItem.name === 'Quarterly Plan'
        ? Math.floor((amount / 13.035) * 100) / 100
        : isQuartlyPlans && planItem.billingCycle === 90
          ? amount / 3
          : divedByWeekvars && planItem.name === 'Monthly Plan'
            ? amount / 4.345
            : YearlyPlans && planItem.name === 'Yearly Plan'
              ? amount / 12
              : amount;
  };

  const finalPrice0 = getFinalPrice(activePlansData[0]);
  const finalPrice1 = getFinalPrice(activePlansData[1]);

  const cheaperPlanInfo =
    finalPrice0 <= finalPrice1
      ? { index: 0, price: finalPrice0, plan: activePlansData[0] }
      : { index: 1, price: finalPrice1, plan: activePlansData[1] };

  if (cheaperPlanInfo.index === 1 && philippinesPlans !== '9m5w16q' && brazilPlans !== '9m4w15q' && !isR2route) {
    activePlansData.reverse();
  }

  useEffect(() => {
    if (
      cheaperPlanInfo &&
      turkeyPlans !== 'var_4' &&
      philippinesPlans !== '9m5w16q' &&
      brazilPlans !== '9m4w15q' &&
      !isR2route
    ) {
      setActivePlan(cheaperPlanInfo?.plan?.name);
      selectMonthlyPlan(cheaperPlanInfo?.plan?.name);
    }
  }, []);

  return {
    isBrazil,
    activePlan,
    RtlSideExp,
    israelPlans,
    replacedValue,
    getFinalPrice,
    isQuartlyPlans,
    activePlansData,
    isLargeCurrency,
    WeeklyPlans_Var,
    templateImageUrl,
    handleTogglePlan,
    isNonTrailDayWise,
    paymentTrialDays,
    formatCurrency,
  };
};
